<template>
  <div class="colorPwmSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="colorPwmSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="colorPwmSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.RelaySSR2ASettings_text1}}
        </template>
        <template v-slot:body>
          <div style="width: 200px;min-height: 100px;" class="lxn-margin-auto">
            <div class="colorPwmSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{colorLabel}}
            </div>
            <div id="lxn-color-picker"></div>
          </div>
        </template>
      </TitleBox>
    </div>
    <div class="colorPwmSettings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="goBack" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.LoginRegister_back}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE11 from '@/statics/devices/Node11/header.js'
import iro from '@jaames/iro';

export default {
  name: 'colorPwmSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
  },
  data: function () {
    var node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);

    return {
      node: node,
      colorPicker: null,
      colorValue: 0,
      colorChangeTimeoutHandle: -1,
      debounceDelay: 100,
      colorLocked: false,
      color: {
        hue: 0,
        saturation: 0,
        value: 0,
      },
    }
  },
  mounted: async function () {
    this.$store.commit('setAppBusy', true);
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    var errorHappened = false;
    try {
      var nodeParameters = await this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid});
      nodeParameters = nodeParameters.body.bodyContent.parameterList;
      this.$store.dispatch('processNodeParameters', {rawParameters: nodeParameters, nodeUUID: this.node.uuid});
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
      this.$store.commit('setAppBusy', false);
    }
    catch (response) {
      errorHappened = true;
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
      alert(this.$store.getters.language.texts.NODE11Settings_alert1);
      this.$router.push('/home/devices/')
      this.$store.commit('setAppBusy', false);
    }
    if(errorHappened){
      return;
    }
    this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
      width: 200,
      borderWidth: 5,
      color: this.paletteColor,
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    if(this.output.name == "Red"){
      this.colorPicker.color.hsv = {
        h: 0,
        s: 100,
        v: Math.floor((iro.Color.hsvToRgb(this.currentColor).r / 255) * 100),
      }
    }else if(this.output.name == "Green"){
      this.colorPicker.color.hsv = {
        h: 120,
        s: 100,
        v: Math.floor((iro.Color.hsvToRgb(this.currentColor).g / 255) * 100),
      }
    }else if(this.output.name == "Blue"){
      this.colorPicker.color.hsv = {
        h: 240,
        s: 100,
        v: Math.floor((iro.Color.hsvToRgb(this.currentColor).b / 255) * 100),
      }
    }else{
      this.colorPicker.color.hsv = {
        h: 0,
        s: 0,
        v: Math.floor((this.currentColor.w / 100) * 100),
      }
    }
    this.colorPicker.on('color:change', this.onColorChange);
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
    if(this.colorPicker){
      this.colorPicker.off('color:change', this.onColorChange);
    }
  },
  watch: {
    currentColor: function (newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
        if(this.colorPicker){
          this.colorLocked = true;
          if(this.output.name == "Red"){
            this.colorPicker.color.hsv = {
              h: 0,
              s: 100,
              v: Math.floor((iro.Color.hsvToRgb(newVal).r / 255) * 100),
            }
          }else if(this.output.name == "Green"){
            this.colorPicker.color.hsv = {
              h: 120,
              s: 100,
              v: Math.floor((iro.Color.hsvToRgb(newVal).g / 255) * 100),
            }
          }else if(this.output.name == "Blue"){
            this.colorPicker.color.hsv = {
              h: 240,
              s: 100,
              v: Math.floor((iro.Color.hsvToRgb(newVal).b / 255) * 100),
            }
          }else{
            this.colorPicker.color.hsv = {
              h: 0,
              s: 0,
              v: Math.floor((newVal.w / 100) * 100),
            }
          }
          this.colorLocked = false;
        }
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    colorLabel: function () {
      if(this.output.name == 'Red'){
        return this.$store.getters.language.texts.Node9Settings_red;
      }else if(this.output.name == 'Green'){
        return this.$store.getters.language.texts.Node9Settings_green;
      }else if(this.output.name == 'Blue'){
        return this.$store.getters.language.texts.Node9Settings_blue;
      }
    },
    paletteColor: function () {
      if(this.output.name == 'Red'){
        return "#F00";
      }else if(this.output.name == 'Green'){
        return "#0F0";
      }else if(this.output.name == 'Blue'){
        return "#00F";
      }else{
        return "#FFF";
      }
    },
    currentColor: function () {
      var currentHue = this.$store.getters.getParameterValue(this.node.index, NODE11.HUE.PARAMETER_ID);
      var currentSaturation = this.$store.getters.getParameterValue(this.node.index, NODE11.SATURATION.PARAMETER_ID);
      var currentValue = this.$store.getters.getParameterValue(this.node.index, NODE11.BRIGHTNESS.PARAMETER_ID);
      if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined){
        var currentColor = {
          h: Math.floor((currentHue / 65535) * 360),
          s: Math.floor((currentSaturation / 65535) * 100),
          v: Math.floor((currentValue / 65535) * 100),
        }
      }else{
        currentColor = {
          h: 0,
          s: 0,
          v: 0,
          w: 0,
        }
      }
      return currentColor;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    onColorChange: function () {
      if(!this.colorLocked){
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });

          var currentRGB = iro.Color.hsvToRgb(this.currentColor);

          if(this.output.name == "Red"){
            currentRGB.r = Math.min(Math.floor((this.colorPicker.color.hsv.v / 100) * 255), 255);
          }else if(this.output.name == "Green"){
            currentRGB.g = Math.min(Math.floor((this.colorPicker.color.hsv.v / 100) * 255), 255);
          }else if(this.output.name == "Blue"){
            currentRGB.b = Math.min(Math.floor((this.colorPicker.color.hsv.v / 100) * 255), 255);
          }
          var currentHSV = iro.Color.rgbToHsv(currentRGB);
          this.color.hue = Math.floor((currentHSV.h / 360) * 65535);
          this.color.saturation = Math.floor((currentHSV.s / 100) * 65535);
          this.color.value = Math.floor(( Math.min(currentHSV.v, 100) / 100) * 65535);

          var actions = [];
          actions.push({
            parameterId: NODE11.ANIMATION_MODE.PARAMETER_ID,
            valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
            typeOfAction: CONFIGS.ACTION_TYPE_SET,
            timeDelay: 0
          });
          actions.push(
            {
              parameterId: NODE11.HUE.PARAMETER_ID,
              valueOfChange: this.color.hue,
              typeOfAction: CONFIGS.ACTION_TYPE_SET,
              timeDelay: 0
            }
          );
          actions.push(
            {
              parameterId: NODE11.SATURATION.PARAMETER_ID,
              valueOfChange: this.color.saturation,
              typeOfAction: CONFIGS.ACTION_TYPE_SET,
              timeDelay: 0
            }
          );
          actions.push(
            {
              parameterId: NODE11.BRIGHTNESS.PARAMETER_ID,
              valueOfChange: this.color.value,
              typeOfAction: CONFIGS.ACTION_TYPE_SET,
              timeDelay: 0
            }
          );

          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: actions
                  },
                ]
              }
            })
            console.log("DONE");
          }
          catch (response) {
            console.log(response);
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    },
  }
}
</script>

<style>
  .colorPwmSettings-topCurve-wrapper {
    height: 200px;
  }
  .colorPwmSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .colorPwmSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .colorPwmSettings-wrapper-fieldTitles {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
    color: #52626C;
  }
</style>
